export default "__VITE_ASSET__B8Qdd_rF__"